<div class="dashboard-container">
  <div class="dashboard-header">
    <h1>{{ titleText }}</h1>
  </div>

  <div class="tabs">
    <button class="tab-button active" type="button">{{ tabText }}</button>
  </div>

  <div class="dashboard-content">
    <div *ngIf="loading" class="loading">{{ loadingText }}</div>
    <div *ngIf="error" class="error">{{ error }}</div>

    <div *ngIf="!loading && !error && calculations.length === 0" class="empty-state">
      <p>{{ emptyStateText }}</p>
    </div>

    <ng-container *ngIf="!loading && !error && calculations.length > 0">
      <!-- Список поставок, если их больше одной -->
      <div *ngIf="!selectedCalculation && calculations.length > 1" class="supplies-table">
        <table>
          <thead>
            <tr>
              <th>{{ columnNumberText }}</th>
              <th>{{ columnRouteText }}</th>
              <th>{{ columnCreatedText }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let calc of calculations" class="clickable-row" (click)="select(calc)">
              <td>#{{ calc.id }}</td>
              <td>
                {{ calc.fromCountryName || '—' }}<span *ngIf="calc.fromCity">, {{ calc.fromCity }}</span>
                →
                {{ calc.toCountryName || '—' }}<span *ngIf="calc.toCity">, {{ calc.toCity }}</span>
              </td>
              <td>{{ calc.createdAt | date:'dd.MM.yyyy' }}</td>
              <td><button type="button" class="btn btn-primary btn-sm">{{ openText }}</button></td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Предпросмотр выбранного расчёта — тот же компонент, что видит грузовладелец -->
      <div *ngIf="selectedCalculation">
        <button *ngIf="calculations.length > 1" type="button" class="btn-back" (click)="backToList()">
          {{ backToListText }}
        </button>
        <app-view-calculation-details
          [calculation]="selectedCalculation"
          [loading]="false"
          [error]="null"
          [showBackButton]="false"
        ></app-view-calculation-details>

        <app-supplier-document [calculationId]="selectedCalculation.id" [readonlyMode]="false"></app-supplier-document>
        <app-contract-upload [calculationId]="selectedCalculation.id" role="SUPPLIER"></app-contract-upload>
      </div>
    </ng-container>
  </div>
</div>
